/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Current_PlanInputs */

const en_current_plan = /** @type {(inputs: Current_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current Plan`)
};

const fr_current_plan = /** @type {(inputs: Current_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan actuel`)
};

const de_current_plan = /** @type {(inputs: Current_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktueller Plan`)
};

const it_current_plan = /** @type {(inputs: Current_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piano attuale`)
};

const ru_current_plan = /** @type {(inputs: Current_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Текущий план`)
};

const es_current_plan = /** @type {(inputs: Current_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan actual`)
};

const zh_cn2_current_plan = /** @type {(inputs: Current_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当前计划`)
};

const ja_current_plan = /** @type {(inputs: Current_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在の計画`)
};

const hi_current_plan = /** @type {(inputs: Current_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्तमान योजना`)
};

const pt_pt2_current_plan = /** @type {(inputs: Current_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plano atual`)
};

/**
* | output |
* | --- |
* | "Current Plan" |
*
* @param {Current_PlanInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const current_plan = /** @type {((inputs?: Current_PlanInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Current_PlanInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_current_plan(inputs)
	if (locale === "de") return de_current_plan(inputs)
	if (locale === "it") return it_current_plan(inputs)
	if (locale === "ru") return ru_current_plan(inputs)
	if (locale === "es") return es_current_plan(inputs)
	if (locale === "zh-CN") return zh_cn2_current_plan(inputs)
	if (locale === "ja") return ja_current_plan(inputs)
	if (locale === "hi") return hi_current_plan(inputs)
	if (locale === "pt-PT") return pt_pt2_current_plan(inputs)
	return en_current_plan(inputs)
});